// ⚠️ `require`, non `import`: questo file esporta con `module.exports` in fondo. Basta una riga
// `import` in cima perche' webpack lo consideri un modulo ES, e a quel punto `module.exports`
// smette di valere come export di default — chi fa `import AuthAPI from './AuthAPI'` riceve
// undefined e la compilazione si ferma. Finche' l'export in fondo resta CommonJS, qui si usa
// `require`.
const { mandaAlPortale } = require("../passaggioPortale");

let permission = function () {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        if (hash === null) {
            global.userData = undefined;
            reject();
            return;
        }

        fetch(global.route.permission, {
            headers: {'x-access-token': hash},
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API permission', responseJson);
                if (typeof responseJson.status !== "undefined") {
                    localStorage.removeItem("hash");
                    sessionStorage.removeItem("userData");
                    reject(responseJson);
                } else {
                    sessionStorage.setItem("userData", JSON.stringify(responseJson));
                    resolve(responseJson);
                }
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};


let login = function (credential) {
    return new Promise(function (resolve, reject) {
        fetch(global.route.login, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                email: credential.email,
                password: credential.password,
                turnstile_token: credential.turnstile_token
            })
        })
            .then((response) => (response.status !== 500) ? response.json() :reject())
            .then((responseJson) => {
                console.log('API login', responseJson);
                // ⚠️ `replace`, non `assign`: queste due tappe non devono lasciare una voce
                // nella cronologia. Chi passa di qui e' un corsista o un docente che finisce
                // sul portale nuovo (vedi passaggioPortale.js): il passaggio SOSTITUISCE la
                // voce corrente, ma se prima c'e' rimasto `/redirect?token=...` il tasto
                // indietro lo riporta nel vecchio gestionale — dove la sessione e' valida e
                // quindi ci resta, invece che nel portale dove deve lavorare. In piu' quel
                // gettone e' gia' speso: tornarci non ha nessun senso utile.
                if (responseJson.status === 'TOO_MANY_SESSIONS') {
                    window.location.replace('/session/error');
                } else if (responseJson.status === 'OTP_SENT') {
                    window.location.replace('/redirect?token=' + responseJson.token);
                } else if (responseJson.status === 'LOGIN_OK') {
                    sessionStorage.setItem("userData", JSON.stringify(responseJson));
                    localStorage.setItem('hash', responseJson.accessToken);

                    // Corsisti e docenti proseguono sul portale nuovo, gia' dentro. Se il
                    // passaggio non parte escono comunque (vedi passaggioPortale.js): `resolve`
                    // avviene SOLO per amministratori e consulenti.
                    mandaAlPortale(responseJson).then((inCorso) => {
                        if (!inCorso) resolve(responseJson.user);
                    });
                } else {
                    reject(responseJson.status)
                }
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

let changePassword = function (credential) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.credentialEdit, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': hash
            },
            body: JSON.stringify({
                old_password: credential.old_password,
                new_password: credential.new_password
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log("changePassword", responseJson);
                if (responseJson.status === "PASSWORD_CHANGE_OK") {
                    localStorage.setItem('hash', responseJson.accessToken);
                    resolve(responseJson);
                } else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

let clearSession = function (id) {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.clientDisconnect, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': hash
            },
            body: JSON.stringify({
                id: id
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                global.checkAuth(responseJson.status);
                console.log("clear session", responseJson);
                if (responseJson.status === "SESSION_CLEARED") {
                    resolve(responseJson);
                } else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

let checkToken = function (token) {
    return new Promise(function (resolve, reject) {

        fetch(global.route.checkToken + '?token=' + token, {
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log("checkToken", responseJson);
                if (responseJson.status === "TOKEN_OK")
                    resolve(responseJson);
                else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

let resetPassword = function (email, turnstileToken) {
    return new Promise(function (resolve, reject) {
        fetch(global.route.resetPassword, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                email: email,
                turnstile_token: turnstileToken
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log("resetPassword", responseJson);
                if (responseJson.status === "RESET_PASSWORD_SENT") {
                    resolve(responseJson);
                } else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

let completeResetPassword = function (password, email, token) {
    return new Promise(function (resolve, reject) {

        fetch(global.route.completeResetPassword + '?token=' + token, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: email,
                new_password: password
            })
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log("completeResetPassword", responseJson);
                if (responseJson.status === "PASSWORD_RESET_OK") {
                    resolve(responseJson);
                } else
                    reject(responseJson);
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

let verifyOTP = function (otp, token) {
    return new Promise(function (resolve, reject) {
        fetch(global.route.verifyOTP + "?token=" + token, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({otp: otp})
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API verifyOTP', responseJson);
                if (responseJson.status === 'LOGIN_OK') {
                    sessionStorage.setItem("userData", JSON.stringify(responseJson.user));
                    localStorage.setItem('hash', responseJson.accessToken);

                    // Stesso passaggio del login normale. Copre chi usa il codice via SMS:
                    // senza questo ramo, proprio loro non arriverebbero MAI al portale nuovo.
                    mandaAlPortale(responseJson.user).then((inCorso) => {
                        if (!inCorso) resolve(responseJson.user);
                    });
                } else {
                    localStorage.removeItem('hash');
                    sessionStorage.removeItem("userData");
                    global.userData = undefined;
                    reject(responseJson);
                }
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

let resendOTP = function (token) {
    return new Promise(function (resolve, reject) {
        fetch(global.route.verifyOTP + "?token=" + token, {
            method: 'GET'
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API resendOTP', responseJson);
                if (responseJson.status === 'OTP_SENT')
                    resolve(responseJson);
                else
                    reject();
            })
            .catch((e) => {
                console.error(e.message);
                reject()
            });
    });
};

let logout = function () {
    return new Promise(function (resolve, reject) {
        const hash = localStorage.getItem('hash');

        fetch(global.route.logout, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': hash
            },
        })
            .then((response) => (response.status !== 500) ? response.json() : reject())
            .then((responseJson) => {
                console.log('API logout', responseJson);

                localStorage.removeItem('hash');
                sessionStorage.removeItem("userData");
                global.userData = undefined;
                window.location.replace('/login');
            }).catch((e) => {
                localStorage.removeItem('hash');
                sessionStorage.removeItem("userData");
                global.userData = undefined;
                window.location.replace('/login');
                reject()
        });
    });
};


const AuthAPI = {
    permission: permission,
    login: login,
    changePassword: changePassword,
    checkToken: checkToken,
    resetPassword: resetPassword,
    completeResetPassword: completeResetPassword,
    verifyOTP: verifyOTP,
    resendOTP: resendOTP,
    clearSession: clearSession,
    logout: logout
};

module.exports = AuthAPI;
